import {getToken, setToken, removeToken} from '@/utils/auth'
import { login,logout, getInfo } from '@/api/user'
import {
    lisFunctionVOTreeMobile,
    getUserInfoAjax2
} from '@/api/baseMsg';



const user = {
    state: {
        token: getToken(),
        name: '',
        avatar: '',
        roles: [],
        funcs: null
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_FUNCS: (state, funcs) => {
            state.funcs = funcs;
        },
    },

    actions: {
         /**
         * user/getListTreeFuns
         * 获取用户所拥有的的功能
         */
        getListTreeFuns({ commit }) {
            return new Promise((resolve, reject) => {
                lisFunctionVOTreeMobile().then(res => {
                    const { data } = res;
                    commit("SET_FUNCS", data);
                    resolve(res);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        // 登录
        login({ commit }, userInfo) {
            const { username, password } = userInfo
            /*return new Promise((resolve, reject) => {

                login({ username: username.trim(), password: password }).then(response => {
                    const  data = response
                    commit('SET_TOKEN', data.token)
                    setToken(data.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })*/
            return new Promise((resolve, reject) => {
                login({username: username.trim(), password: password}).then(response => {
                    const data = response;
                    if (!data.success) {
                        alert(data.info)
                    }
                    commit('SET_TOKEN', data.token)
                    setToken(data.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // login({commit}, userInfo) {
        //     return new Promise((resolve, reject) => {
        //         api.login(userInfo).then(res => {
        //             if (res.code === 200) {
        //                 setToken(res.data)
        //                 commit('SET_TOKEN', res.data)
        //             }
        //             resolve()
        //         }).catch(err => {
        //             reject(err)
        //         })
        //     })
        // },

        // 获取用户信息
        getInfo({commit, state}) {
            return new Promise((resolve, reject) => {

                getUserInfoAjax2(state.token).then(response => {
                    const {data} = response

                    if (!data) {
                        removeToken()
                        location.reload()
                        return
                    }

                    const {roles, userName, avatar, introduction} = data

                    // roles must be a non-empty array
                    if (!roles || roles.length <= 0) {
                        reject('getInfo: roles must be a non-null array!')
                    }

                    commit('SET_ROLES', roles)
                    commit('SET_NAME', userName)
                    // commit('SET_AVATAR', avatar)
                    // commit('SET_INTRODUCTION', introduction)
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        resetToken({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                removeToken()
                resolve()
            })
        },
        // 前端 登出
        logout({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    removeToken()
                    // resetRouter()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}

export default user
